import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { HIGHCHARTS_MODULES } from 'angular-highcharts';
import { defaultInterpolationFormat, I18NextModule, I18NextTitle, I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import * as grouped from 'highcharts-grouped-categories/grouped-categories';
import * as exporting from 'highcharts/modules/exporting';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend/cjs';
import { ColorSketchModule } from 'ngx-color/sketch';
import { LoggerModule } from "ngx-logger";
import { environment } from '../environments/environment';
import { AppComponent } from './app-component/app.component';
import { AppRoutingModule } from './app-routing.module';
import { DialogBackComponent } from './common/dialogs/dialog-back/dialog-back.component';
import { DialogConfirmComponent } from './common/dialogs/dialog-confirm/dialog-confirm.component';
import { DialogDeleteComponent } from './common/dialogs/dialog-delete/dialog-delete.component';
import { DialogDeleteNewComponent } from './common/dialogs/dialog-delete-new/dialog-delete-new.component';
import { DialogHelpComponent } from './common/dialogs/dialog-help/dialog-help.component';
import { MessagesComponent } from './common/messages/messages.component';
import { DashboardModule } from './dashboards/dashboard.module';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found-component';
import { StatusModule } from './pages/status/status.module';
import { ReportsModule } from './reports/reports.module';
import { ServicesModule } from './services/services.module';
import { EnvironmentService } from './services/services/environmet.service';
import { appEffects } from './state/app.effects';
import { appReducer } from './state/app.reducer';
// import { AngularResizeEventModule } from 'angular-resize-event';
import { AngularResizeEventModule } from 'angular-resize-event-package';
import { EnquiryRegistrationModule } from './enquiry-registration/enquiry-registration.module';
import { ArchiveExternalAccessModule } from './archive-external-access/archive-external-access.module';
import { CallbackDisplayModule } from './callback-display/callback-display.module';
import { RealTimeModule } from './real-time/real-time.module';
import { UsersModule } from './users/users.module';
import { LazyElementsModule } from '@angular-extensions/elements';
import { HomeModule } from './home/home.module';

import { SharedModule } from './shared/shared.module';
new EnvironmentService().load();

export function appInit(i18next: ITranslationService) {
  return () => i18next
  .use<any>(LanguageDetector)
  .use(Backend)
  .init({
      supportedLngs: ['EN','NO','DK','SE'],
      fallbackLng: 'EN',
      debug: true,
      returnEmptyString: false,
      ns: [
        'translation',
        'dashboard',
        'messages',
        'archive',
        'callbackDisplay',
        'realtime',
        'ticker',
        'users',
        'audit',
        'home'
      ],
      nsSeparator: ':',
      interpolation: {
        format: I18NextModule.interpolationFormat(defaultInterpolationFormat)
      },
      backend: {
        loadPath: 'assets/i18n/{{lng}}.{{ns}}.json',
      },
      detection: {
        order: ['localStorage'],
        lookupLocalStorage: 'puzzel_languageCode'
      }
    });
}
export function localeIdFactory(i18next: ITranslationService)  {
  return i18next.language;
}
export const I18N_PROVIDERS = [
{
  provide: APP_INITIALIZER,
  useFactory: appInit,
  deps: [I18NEXT_SERVICE],
  multi: true
},
{
  provide: Title,
  useClass: I18NextTitle
},
{
  provide: LOCALE_ID,
  deps: [I18NEXT_SERVICE],
  useFactory: localeIdFactory
}];

@NgModule({
    declarations: [
        AppComponent,
        MessagesComponent,
        DialogBackComponent,
        DialogDeleteComponent,
        DialogDeleteNewComponent,
        PageNotFoundComponent,
        DialogHelpComponent,
        DialogConfirmComponent
    ],
    imports: [
        BrowserModule,
        StoreModule.forRoot({ mainState: appReducer }),
        EffectsModule.forRoot([appEffects]),
        StatusModule,
        DashboardModule,
        ReportsModule,
        AppRoutingModule,
        HttpClientModule,
        ServicesModule,
        LoggerModule.forRoot(environment.NgxLoggerSettings),
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production, autoPause: true, name: "Dashboard" }),
        I18NextModule.forRoot(),
        BrowserAnimationsModule,
        MatButtonModule,
        MatDialogModule,
        FormsModule,
        ColorSketchModule,
        AngularResizeEventModule,
        EnquiryRegistrationModule,
        ArchiveExternalAccessModule,
        CallbackDisplayModule,
        RealTimeModule,
        HomeModule,
        UsersModule,
        LazyElementsModule,
        SharedModule
    ],
    providers: [Title, I18N_PROVIDERS, { provide: HIGHCHARTS_MODULES, useFactory: () => [grouped, exporting] }, { provide: LOCALE_ID, useValue: "en-GB" }],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
